import { render, staticRenderFns } from "./Syck.vue?vue&type=template&id=1e74ffe4&scoped=true&"
import script from "./Syck.vue?vue&type=script&lang=js&"
export * from "./Syck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e74ffe4",
  null
  
)

export default component.exports